/**
 * CalendarInventoryCapacityMode
 */
export enum CalendarInventoryCapacityMode {
    IRRELEVANT = 'irrelevant',
    FIXED = 'fixed',
    ALTERABLE = 'alterable'
}
